import { Link } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconChart, IconEdit } from '../../../common/icons';
import { useLab } from '../contexts/labs';

import '../../../common/styles/catalog.css';

const STATUS_LABEL = { 2: 'Activo', 1: 'Inactivo', 0: 'Eliminado' };

function Field({ label, value }) {
    return (
        <div className="cat-detail__field">
            <span className="cat-detail__field-label">{label}</span>
            <span className="cat-detail__field-value">
                {value || <span className="cat-detail__empty">—</span>}
            </span>
        </div>
    );
}

export default function LabDetail({ labId }) {
    const { data: lab, isLoading, error } = useLab(labId);

    if (isLoading) return <div className="cat-detail__state">Cargando laboratorio…</div>;
    if (error || !lab) return <div className="cat-detail__state">Laboratorio no encontrado.</div>;

    return (
        <div className="cat-detail">
            <header className="cat-detail__header">
                <div>
                    <Link to="/admin/labs" className="cat-detail__back">Laboratorios</Link>
                    <div className="cat-detail__title-row">
                        <h1 className="cat-detail__title">{lab.name}</h1>
                        <span className={`cat-badge cat-badge--${lab.status}`}>{STATUS_LABEL[lab.status] || '—'}</span>
                    </div>
                </div>
                <div className="cat-detail__actions">
                    <Gate domain="kpis" action="read">
                        <Link to={`/admin/labs/${lab.id}/stats`} className="cat-detail__edit">
                            <IconChart /><span>Estadísticas</span>
                        </Link>
                    </Gate>
                    <Gate domain="labs" action="write">
                        <Link to={`/admin/labs/${lab.id}/edit`} className="cat-detail__edit">
                            <IconEdit /><span>Editar</span>
                        </Link>
                    </Gate>
                </div>
            </header>

            <section className="cat-detail__card">
                <h2 className="cat-detail__section-title">Información</h2>
                <div className="cat-detail__grid">
                    <Field label="Ubicación" value={lab.location} />
                    <Field label="Estado" value={STATUS_LABEL[lab.status]} />
                </div>
            </section>
        </div>
    );
}
